import { createSlice } from "@reduxjs/toolkit"

let userSlice = createSlice({
    name: 'user-slice',
    initialState: {
        userId: null,
        socket: null
    },
    reducers: {
        updateUserId: (state, action) => {
            state.userId = action.payload
        },
        updateSocket: (state, action) => {
            state.socket = action.payload.skt
        }
    },
})

export default userSlice.reducer
export const { updateUserId, updateSocket } = userSlice.actions